export default __webpack_public_path__ + "static/media/icons8-chat-48.3a75477e.svg";